module.exports = __webpack_public_path__ + "img/numbersOrderOn.3f9beff4.svg";